
import { initRestaurantsMap } from "./../js/restaurantsMap/initRestaurantsMap.jsx";

initRestaurantsMap("restaurants-map");
